module.exports = __webpack_public_path__ + "img/jmv-logo.1b5078b5.svg";